// Boxo Mini App IDs from environment variables
const BOXO_TRAVEL_ESIMS_APP_ID = import.meta.env.VITE_BOXO_TRAVEL_ESIMS_APP_ID
const BOXO_AIRPORT_LOUNGES_APP_ID = import.meta.env
  .VITE_BOXO_AIRPORT_LOUNGES_APP_ID
const BOXO_HOTELS_APP_ID = import.meta.env.VITE_BOXO_HOTELS_APP_ID
const BOXO_FLIGHTS_APP_ID = import.meta.env.VITE_BOXO_FLIGHTS_APP_ID

export const boxoMiniAppIds = {
  travelESIMs: BOXO_TRAVEL_ESIMS_APP_ID || '',
  airportLounges: BOXO_AIRPORT_LOUNGES_APP_ID || '',
  hotels: BOXO_HOTELS_APP_ID || '',
  flights: BOXO_FLIGHTS_APP_ID || '',
}

export enum BoxoBannersEnumID {
  travelESIMs = 'travelESIMs',
  airportLounges = 'airportLounges',
  hotels = 'hotels',
  flights = 'flights',
}

export type BoxoMiniAppType = keyof typeof boxoMiniAppIds
